/* eslint-disable react/no-array-index-key */
import ButtonWithSpinner from 'components/common/ButtonWithSpinner';
import { ConfirmButton } from 'components/common/DefaultFormButton';
import { Form, Formik } from 'formik';
import React from 'react';

import { useLocationFormProps } from './hooks';
import { ILocationFormProps } from './types';

const LocationForm: React.FC<ILocationFormProps> = ({ refetchLocation, closeModal }) => {
  const {
    currentFormStep,
    initialValues,
    hasNext,
    hasPrevious,
    onNext,
    onPrevious,
    onSubmit,
    schema,
    formComponentsBySteps,
    submitLoading,
  } = useLocationFormProps({
    callbackOnSuccess: () => {
      refetchLocation?.();
      closeModal?.();
    },
  });

  const onSubmitForm = (v: Record<string, any>, { resetForm }: any) => {
    if (hasNext) {
      onNext(v);
    } else {
      onSubmit(v, resetForm);
    }
  };

  return (
    <Formik onSubmit={onSubmitForm} initialValues={initialValues} validationSchema={schema}>
      <Form className='gx-signin-form gx-form-row0'>
        {formComponentsBySteps.map(({ component }, index) => (
          <div
            className='overflow-y-auto'
            key={index}
            style={{ display: index === currentFormStep ? undefined : 'none' }}>
            {component}
          </div>
        ))}
        <div className='m-0 p-4 flex justify-center border-t border-border_color'>
          <ConfirmButton isLoading={submitLoading} htmlType='submit'>
            {hasNext ? 'Next' : 'Create'}
          </ConfirmButton>
          {hasPrevious && (
            <ButtonWithSpinner bgColor='white' color='#545454' colorOnHover='inherit' onClick={onPrevious}>
              Previous
            </ButtonWithSpinner>
          )}
        </div>
      </Form>
    </Formik>
  );
};

export default React.memo(LocationForm);
